import { FactoryNodeScreenConfigCommandType } from "../enums/factory-node-screen-config-command-type.enum";
import { FactoryNodeConfig } from "../models/factory-node-config.model";

export function generateFactoryNodeScreenCommandDefinitions(config: FactoryNodeConfig): string {

    if (config.screenConfigs.length === 0) return ""

    const imports = `import { Subject, Observable } from "rxjs";\n\n`

    let model_node = `
    /**
     * Defines the screen command definitions from the perspective of the factory node.
     * Screen commands originate from the screen, so they are read-only for the factory node.
     */
    \n\n export interface Screens__Node {`

    let object_node = `
    /**
     * The command control object for the factory node. Listen to these to get the incoming commands from the screens.
     */
    export const screens__node: Screens__Node = {`

    let model_screen = `
    /**
     * Defines the screen command definitions from the perspective of the screen.
     * Screen commands originate from the screen, so these are regular subjects that you can .next().
     * Any event emissions will be sent to the factory node for processing.
     */
    \n\n export interface Screens__Screen {`

    let object_screen = `
    /**
     * The command control object for the screen.
    * Screen commands originate from the screen, so these are regular subjects that you can .next().
    * Any event emissions will be sent to the factory node for processing.
     */
    export const screens__screen: Screens__Screen = {`




    config.screenConfigs.forEach((screen) => {

        if (screen.commands.length > 0) {

            model_node += `\n    ${screen.machineName}: {`
            object_node += `\n    ${screen.machineName}: {`

            model_screen += `\n    ${screen.machineName}: {`
            object_screen += `\n    ${screen.machineName}: {`

            // model += `${screen.machineName}: {\n`
            // object += `${screen.machineName}: {\n`

            screen.commands.forEach((command) => {
                let typeString = command.type === FactoryNodeScreenConfigCommandType.Boolean ? "boolean" :
                    command.type === FactoryNodeScreenConfigCommandType.Number ? "number" :
                        command.type === FactoryNodeScreenConfigCommandType.String ? "string" :
                            command.type === FactoryNodeScreenConfigCommandType.Void ? "void" : "any"

                // These are made to be read-only since you can't dispatch screen commands from the factory node.
                model_node += `${command.machineName}: Observable<${typeString}>;\n`
                object_node += `${command.machineName}: new Subject<${typeString}>().asObservable(),\n`


                model_screen += `${command.machineName}: Subject<${typeString}>;\n`
                object_screen += `${command.machineName}: new Subject<${typeString}>(),\n`
            })

            model_node += `},\n`
            object_node += `},\n`

            model_screen += `},\n`
            object_screen += `},\n`

        }
    })

    model_node += `}`
    object_node += `}`
    model_screen += `}`
    object_screen += `}`

    const combined = `${imports}\n\n${model_node}\n\n${object_node}\n\n${model_screen}\n\n${object_screen}`


    return combined
}
